import { MBox } from '@/theme/common'

export default function License() {
  return (
    <MBox alternative style={{ marginTop: '1rem', marginBottom: '1rem' }}>
      <a href="https://viralpubliclicense.org/" target="_blank" rel="noopener noreferrer">
        VIRAL PUBLIC LICENSE
        <br />
        Copyleft (ɔ) All Rights Reversed
      </a>
    </MBox>
  )
}
